import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from '../ui/Button';

const VersionSelectionModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSimpleVersion = () => {
    navigate('/simplified-version');
    onClose();
  };

  const handleDetailedVersion = () => {
    navigate('/wealth-dashboard');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-card rounded-lg border border-border shadow-xl max-w-2xl w-full mx-4 p-6 sm:p-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-foreground">
            Choose Your Planning Approach
          </h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <p className="text-muted-foreground mb-8">
          How would you like to plan your retirement?
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* Simple Version */}
          <div className="border border-border rounded-lg p-6 hover:border-primary/50 transition-colors">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="Zap" size={24} className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground">
                Quick Insight Mode
              </h3>
            </div>
            <p className="text-muted-foreground mb-4">
              Quick retirement check with just 4 steps
            </p>
            <ul className="space-y-2 mb-6 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Time required: ~2 minutes
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Get instant feedback
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Perfect for quick assessment
              </li>
            </ul>
            <Button
              onClick={handleSimpleVersion}
              className="w-full"
              variant="default"
            >
              Start Simple Version
            </Button>
          </div>

          {/* Detailed Version */}
          <div className="border border-border rounded-lg p-6 hover:border-primary/50 transition-colors">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name="BarChart3" size={24} className="text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-foreground">
                Precision Mode
              </h3>
            </div>
            <p className="text-muted-foreground mb-4">
              Full-featured retirement planning
            </p>
            <ul className="space-y-2 mb-6 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Time required: 30+ minutes
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Multiple income sources
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Detailed asset allocation
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Category-wise expenses
              </li>
              <li className="flex items-center gap-2">
                <Icon name="Check" size={16} className="text-primary" />
                Advanced projections
              </li>
            </ul>
            <Button
              onClick={handleDetailedVersion}
              className="w-full"
              variant="outline"
            >
              Start Detailed Version
            </Button>
          </div>
        </div>

        <p className="text-sm text-muted-foreground text-center">
          💡 You can switch between versions anytime
        </p>
      </div>
    </div>
  );
};

export default VersionSelectionModal;

